
/*!
 * SwZoomBox - v0.0.1 - 2018-12-11
 * github: necmi
 */

const SwZoomBox = function (target) {
    if (!(this instanceof SwZoomBox)) return new SwZoomBox(target)

    this.body = document.querySelector("body");

    this.target = document.querySelector(target)
    this.images = this.target.querySelectorAll('img')



    this.$image = new Image()
    this.desc = document.createElement('div')

    this.src = []
    this.alt = []
    this.x;
    this.y;
    this.count = 0;
    this.counter = 0;
    this.starter = 0;

    this.scaleImage()

    this.$image.className = 'main-image'

    document.onmousemove = this.handleMouse;

}

SwZoomBox.prototype.getSrcImages = function () {
    const _context = this

    for (var i = 0; i < this.images.length; i++) {
        _context.src.push(_context.images[i].src.replace("_enbuyuk.jpg?height=758", "_enbuyuk.jpg").replace("_enbuyuk.jpg?height=758", "_enbuyuk.jpg"))
    }

    return this.src
}


SwZoomBox.prototype.getAltImages = function () {
    const _context = this

    for (var i = 0; i < this.images.length; i++) {
        _context.alt.push(_context.images[i].alt)
    }

    return this.alt
}

SwZoomBox.prototype.hideAndShow = function () {
    const _context = this

    this.$image.style.opacity = 0

    setTimeout(function () {
        if (screen.width <= 767) {
            var transform = "translate3d(0px, 0px, 0px) " + "scale3d(1, 1, 1) ";
            _context.$image.style.webkitTransform = transform;
        }
        _context.$image.src = _context.getSrcImages()[_context.count]
        _context.$image.style.opacity = 1
    }, 200)
}

SwZoomBox.prototype.next = function () {
    this.count++

    if (this.count >= this.images.length) this.count = 0

    this.hideAndShow()


}

SwZoomBox.prototype.back = function () {

    const _len = this.images.length - 1

    this.count--

    if (this.count < 0) this.count = _len

    this.hideAndShow()
}





SwZoomBox.prototype.showImage = function () {
    window.conte = this
    const _context = this
    const _elem = document.createElement('div')
    const _back = document.createElement('button')
    const _next = document.createElement('button')
    const _close = document.createElement('button')
    
    var hammerIt = this.hammerIt;
    
    _elem.setAttribute('role', 'dialog')

    _next.innerHTML = ''
    _back.innerHTML = ''
    _close.innerHTML = ''

    _close.title = 'Close'
    _back.title = 'Geri'
    _next.title = 'İleri'


    _elem.className = 'fancy'
    _back.className = 'left'
    _next.className = 'right'
    _close.className = 'close'


    this.desc.className = 'desc'

    _next.addEventListener('click', function () {
        _context.next()
    })


    _back.addEventListener('click', function () {
        _context.back()
    })


    Array.prototype.forEach.call(this.images, function (items) {
        

        items.style.cursor = 'pointer'
        items.setAttribute('counter', _context.counter++)

        items.addEventListener('click', function (event) {

            _context.$image.src = this.src.replace("_enbuyuk.jpg?height=758", "_enbuyuk.jpg").replace("_enbuyuk.jpg?height=758", "_enbuyuk.jpg")
            _context.$image.alt = this.alt

            _context.body.classList.add("ShowZoomBox");
            _close.setAttribute('onclick', 'this.parentNode.remove();document.querySelector("body").classList.remove("ShowZoomBox");')

            _elem.addEventListener("click", function (e) {

                if (e.target.className.indexOf("fancy") != -1) {
                    this.remove();
                    document.querySelector("body").classList.remove("ShowZoomBox");
                }

            });
            
            hammerIt(_context.$image, _context)

            _elem.appendChild(_context.$image)
            _elem.appendChild(_back)
            _elem.appendChild(_next)
            _elem.appendChild(_context.desc)
            _elem.appendChild(_close)


            document.body.appendChild(_elem)

            _context.count = parseInt(this.getAttribute('counter'))

        })

    })


}

SwZoomBox.prototype.hammerIt = function (elm,_context) {
    window.contextt = _context
    hammertime = new Hammer(elm, {});
    hammertime.get('pinch').set({
        enable: true
    });
    var posX = 0,
        posY = 0,
        scale = 1,
        last_scale = 1,
        last_posX = 0,
        last_posY = 0,
        max_pos_x = 0,
        max_pos_y = 0,
        transform = "",
        el = elm;
    
    //// SWIPE İLE RESİM DEĞİŞTİRME İŞLEMİ

    //hammertime.on('swiperight', function (e) {
    //    _context.next();
    //});

    //hammertime.on('swipeleft', function (e) {
    //    _context.back();
    //});

    //// SWIPE İLE RESİM DEĞİŞTİRME İŞLEMİ - SON

    hammertime.on('doubletap pan pinch panend pinchend', function (ev) {
        if (ev.type == "doubletap") {
            transform =
                "translate3d(0, 0, 0) " +
                "scale3d(2, 2, 1) ";
            scale = 2;
            last_scale = 2;
            try {
                if (window.getComputedStyle(el, null).getPropertyValue('-webkit-transform').toString() != "matrix(1, 0, 0, 1, 0, 0)") {
                    transform =
                        "translate3d(0, 0, 0) " +
                        "scale3d(1, 1, 1) ";
                    scale = 1;
                    last_scale = 1;
                }
            } catch (err) { }
            el.style.webkitTransform = transform;
            transform = "";
        }

        //pan    
        if (scale != 1) {
            posX = last_posX + ev.deltaX;
            posY = last_posY + ev.deltaY;
            max_pos_x = Math.ceil((scale - 1) * el.clientWidth / 2);
            max_pos_y = Math.ceil((scale - 1) * el.clientHeight / 2);
            if (posX > max_pos_x) {
                posX = max_pos_x;
            }
            if (posX < -max_pos_x) {
                posX = -max_pos_x;
            }
            if (posY > max_pos_y) {
                posY = max_pos_y;
            }
            if (posY < -max_pos_y) {
                posY = -max_pos_y;
            }
        }


        //pinch
        if (ev.type == "pinch") {
            scale = Math.max(.999, Math.min(last_scale * (ev.scale), 4));
        }
        if (ev.type == "pinchend") { last_scale = scale; }

        //panend
        if (ev.type == "panend") {
            last_posX = posX < max_pos_x ? posX : max_pos_x;
            last_posY = posY < max_pos_y ? posY : max_pos_y;
        }

        if (scale != 1) {
            transform =
                "translate3d(" + posX + "px," + posY + "px, 0) " +
                "scale3d(" + scale + ", " + scale + ", 1)";
        }

        if (transform) {
            el.style.webkitTransform = transform;
        }
    });
}



SwZoomBox.prototype.scaleImage = function () {
    var image = this.$image;
    image.addEventListener('click', function () {

        if (this.naturalWidth == 733 && !this.classList.contains('zoom')) {

        } else {
            if (screen.width >= 767) {

                document.querySelector(".fancy").scrollTop = 0;
                document.querySelector(".fancy").scrollLeft = 0;
                this.classList.toggle('zoom')
                document.querySelector("body").classList.toggle("mobileZoom")
            }

        }

    })

}



SwZoomBox.prototype.handleMouse = function (e) {

    if (document.body.classList.contains('ShowZoomBox')) {

        if (this.x && this.y) {
            document.querySelector(".fancy").scrollTop += (e.clientY + 250) - (this.y + 250);
        }

        this.x = e.clientX;
        this.y = e.clientY;
    }

}









